// extracted by mini-css-extract-plugin
export var content = "_ob-1";
export var fullScreen = "_ob-0";